import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'
import { FbuChanceAnalysisParams, ChanceSaleList, BriefReportParams, HomePageVisitPlanByMonthParams, HomePageVisitPlanByWeekParams, SourceListParams, UserListParams, BackKeyData, BackMonthData } from '@/typings/api/index'

/**
 * ************************************** 首页 **************************************
 */
// 商机分析
export function chanceAnalysis(data?: FbuChanceAnalysisParams) {
  return request.post<AxiosResult>('/lbu/api/homePage/analysisList', data)
}
// 查询机会金额
export function chanceSaleList(data?: FbuChanceAnalysisParams) {
  return request.post<AxiosResult<ChanceSaleList[]>>('/lbu/api/homePage/saleList', data)
}
// 机会分析
export function getBriefReport(data?: BriefReportParams) {
  return request.post<AxiosResult, AxiosResult<BackKeyData>>('/lbu/api/homePage/getBriefReport', data)
}
// 根据月获取待跟进客户日历
export function getHomePageVisitPlanByMonth(data?: HomePageVisitPlanByMonthParams) {
  return request.post<AxiosResult, AxiosResult<BackMonthData>>('/lbu/api/homePage/getHomePageVisitPlanByMonth', data)
}
// 获取待跟进客户日历
export function getHomePageVisitPlanYT(data?: HomePageVisitPlanByMonthParams) {
  return request.post<AxiosResult, AxiosResult<BackMonthData>>('/lbu/api/homePage/getHomePageVisitPlan', data)
}
// 根据周获取待跟进客户日历
export function getHomePageVisitPlanByWeek(data?: HomePageVisitPlanByWeekParams) {
  return request.post<AxiosResult>('/lbu/api/homePage/getHomePageVisitPlanByWeek', data)
}
// 线索来源统计
export function sourceList(data?: SourceListParams) {
  return request.post<AxiosResult>('/lbu/api/homePage/sourceList', data)
}
// 按负责人统计
export function userList(data?: UserListParams) {
  return request.post<AxiosResult>('/lbu/api/homePage/userList', data)
}
